import { render, staticRenderFns } from "./CreateTenantPopUp.vue?vue&type=template&id=6f2be021&scoped=true"
import script from "./CreateTenantPopUp.vue?vue&type=script&lang=js"
export * from "./CreateTenantPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateTenantPopUp.vue?vue&type=style&index=0&id=6f2be021&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2be021",
  null
  
)

export default component.exports